export const T_NUMBER = ''; // '', 2, 3, 4, 5
export const EXT_URL = 'api-ext-v2.apc-dev02.azure.to2cz.cz';
export const INT_URL = 'api-int-v2.apc-dev02.azure.to2cz.cz';
